import moment from "moment";

export const thousandSeparator = (number) => {
  let parts = number.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return parts.join(",");
};

export const formatNumberComma = (number, after = 2) => {
  let num = parseFloat(number);
  if (num === 0) return 0;

  return num.toFixed(after).replace(/\.?0+$/, "");
};

export const isImageFile = (filename) => {
  const extention = getExtentionFile(filename);
  return /(jpe?g|jpg|png|gif|bmp)$/i.test(extention);
};

export const getExtentionFile = (filename) => {
  return (filename.match(/\.([^.]*?)(?=\?|#|$)/) || [])[1];
};

export const validateFile = (filetype) => {
  let valid = false;
  const splitFile = filetype.split("/");
  if (/(jpe?g|jpg|png|gif|bmp)$/i.test(splitFile[1])) {
    valid = true;
  } else if (/(pdf)$/i.test(splitFile[1])) {
    valid = true;
  }
  return valid;
};

export const allowances = [
  {
    min: 0,
    max: 1000000,
  },
  {
    min: 1000000,
    max: 2000000,
  },
  {
    min: 2000000,
    max: 3000000,
  },
  {
    min: 3000000,
    max: 4000000,
  },
  {
    min: 4000000,
    max: 5000000,
  },
];

export const isUnder21 = (value1, value2) => {
  const date1 = moment(value1).startOf("day");
  const date2 = moment(value2).startOf("day");

  // Returns exact floating point years (e.g. 20.95 or 21.2)
  const exactYears = date2.diff(date1, "years", true);

  // Must be positive (value2 > value1) and strictly under 21
  return exactYears < 22;
};

export const isUpTo45 = (value1, value2) => {
  const date1 = moment(value1).startOf("day");
  const date2 = moment(value2).startOf("day");

  // Return false if either date is invalid
  if (!date1.isValid() || !date2.isValid()) {
    return false;
  }

  // Calculate full fractional years difference (e.g. 45.3)
  const diffInYears = date2.diff(date1, "years", true);

  // Checks if the difference is non-negative and 45 years or less
  return diffInYears > 45;
};

export const isLoanUpTo50 = (loan) => {
  const {
    loan_detail: { loan_amount_education, allowance },
  } = loan;

  return loan_amount_education + allowance > 50000000;
};
